import { allOrganizationsService } from '../../../services/boteria/allOrganization';

export function allOrganizationsAction (token) {
  return {
    type: 'GET_ALL_ORGANIZATIONS',
    payload: allOrganizationsService(token)
  }
}